export default function makeGetCellsCoords(store) {
  return {
    getCellsCoords: function getCellsCoords(editor, cells) {
      return cells.map(editor.getCellCoords);
    }
  };
}